module.exports = __webpack_public_path__ + "img/singopic-icon.53069343.svg";